// Enhance existing headings without rewriting policy content.
document.querySelectorAll('.af-policy-page .shopify-policy__body p').forEach((p)=>{
 const text=p.textContent.trim();
 if (/^(SECTION \d+\s*[-–]|OVERVIEW$)/.test(text) && text.length<130 && !p.querySelector('br')) {
  p.classList.add('af-policy-subheading');
 } else if (p.firstChild?.nodeType===Node.TEXT_NODE && p.querySelector('br')) {
  const first=p.firstChild;
  if(first.textContent.trim().length>0 && first.textContent.trim().length<90 && first.nextSibling?.nodeName==='BR'){
   const heading=document.createElement('strong');heading.className='af-policy-inline-heading';
   first.before(heading);heading.append(first);
  }
 }
});
